import { createFeatureSelector } from '@ngrx/store';

export const locationsImagesState = createFeatureSelector<OLO.State, OLO.State.LocationsImages>('locationsImages');
